import { WishlistProvider } from '@components/WishlistProvider/WishlistProvider'

export const withWishlist = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <WishlistProvider>
        <WrappedComponent {...props} />
      </WishlistProvider>
    )
  }
}
